export default __webpack_public_path__ + "static/summer_containers77-0380d969a7536585ecf2f99b57939c5a.webp";